export var schemaPlace = function (placeData) {
    var place = {
        city: "",
        country: "",
        region: "",
    };
    var regions = [];
    placeData.forEach(function (p) {
        if (p.placeType === "region") {
            regions.push(p.name);
        }
        else {
            place[p.placeType] = p.name;
        }
    });
    if (regions.length) {
        place.region = regions[0];
    }
    return place;
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/schemaPlace.ts
// module id = 37xT
// module chunks = 2